import React from 'react';
import { useMediaQuery } from 'react-responsive';
import DesktopNavbar from './DesktopNavbar'; // Your original navbar
import MobileNavbar from './MobileNavbar'; // New mobile navbar

const Navbar = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      {isMobile ? <MobileNavbar /> : <DesktopNavbar />}
    </>
  );
};

export default Navbar;